export enum ExperienceLevel {
  LESS_THAN_SIX_MONTHS = "LESS_THAN_SIX_MONTHS",
  LESS_THAN_A_YEAR = "LESS_THAN_A_YEAR",
  MORE_THAN_A_YEAR = "MORE_THAN_A_YEAR",
  NONE = "NONE",
}

export enum HeardAboutUs {
  WORD_OF_MOUTH = "WORD_OF_MOUTH",
  SOCIAL_NETWORK = "SOCIAL_NETWORK",
  LOCAL_ADVERTISING = "LOCAL_ADVERTISING",
  ONLINE_SEARCH = "ONLINE_SEARCH",
  SPORTS_EVENTS_COMPETITIONS = "SPORTS_EVENTS_COMPETITIONS",
  PASSED_BY = "PASSED_BY",
  INFLUENCERS_AMBASSADORS = "INFLUENCERS_AMBASSADORS",
  OTHER = "OTHER",
}

export enum LeadType {
  CONTACTED_FROM_SHOWCASE = "CONTACTED_FROM_SHOWCASE",
  MANUAL_ADDITION = "MANUAL_ADDITION",
  TRIAL_SESSION = "TRIAL_SESSION",
  INTERRUPTED_PURCHASE = "INTERRUPTED_PURCHASE",
}

export enum Goals {
  LOSE_WEIGHT = "LOSE_WEIGHT",
  GETTING_BACK_INTO_SPORT = "GETTING_BACK_INTO_SPORT",
  RETURN_TO_EXERCISE_AFTER_AN_INJURY = "RETURN_TO_EXERCISE_AFTER_AN_INJURY",
  PERFORMANCE = "PERFORMANCE",
  OTHER = "OTHER",
}
